import {AxiosResponse} from 'axios';
import logger from 'utils/logger';

export const responseSuccessHandler = (response: AxiosResponse) => {
  logger.addBreadcrumb('api:responseSuccessHandler', {data: response.data});
  if (response.data && response.headers['content-type'] === 'application/json') {
    return response.data;
  }
  return response;
};
